<template>
  <div class="login">
    <NavbarMain />
    <div class="mt-5">
      <h2 class="text-center">Iniciar sesión</h2>
    </div>
    <form class="container pt-5 container-login">
      <div class="form-group">
        <label for="exampleInputEmail1">Nombre de usuario</label>
        <input
          type="text"
          class="form-control"
          aria-describedby="emailHelp"
          placeholder="Ingrese su nombre de usuario"
          v-model="email"
        />
      </div>
      <div class="form-group">
        <label for="exampleInputPassword1">Contraseña</label>
        <input
          :type="typePassword"
          class="form-control"
          placeholder="Ingrese su contraseña"
          v-model="password"
          @keyup.enter="login()"
        />
        <span
          @click="showPassword"
          class="material-icons cursor-pointer text-secondary"
          style="position: relative; top: -30px; right: -94%"
          >visibility_off
        </span>
      </div>
      <div class="text-center">
        <p class="text-danger" :class="!onErrorLogin ? 'd-none' : ''">
          Usuario o contraseña incorrectos.
        </p>
        <span @click="login" class="btn btn-treid">
          <span :class="onLogin ? 'd-none' : ''">Iniciar sesión</span>
          <div
            class="spinner-border"
            role="status"
            :class="!onLogin ? 'd-none' : ''"
          >
            <span class="sr-only">Loading...</span>
          </div>
        </span>
        <p class="mt-3 text-center">
          Todavía no tienes una cuenta?
          <router-link to="/sistemaapple" class="text-blue"
            >Click aquí para registrarte.</router-link
          >
        </p>
      </div>
    </form>
    <ModalWarningLogin :visible="modalVisble" />
  </div>
</template>
<script>
import Api from "../tools/Api2";
import NavbarMain from "@/components/NavbarMain.vue";
import ModalWarningLogin from "@/components/modals/ModalWarningLogin.vue";
import { mapMutations, mapState } from "vuex";

export default {
  name: "Login",
  components: {
    NavbarMain,
    ModalWarningLogin,
  },
  data() {
    return {
      email: "",
      password: "",
      onLogin: false,
      onErrorLogin: false,
      modalVisble: false,
      typePassword: "password",
    };
  },

  created() {
    if (this.auth.jwt) this.$router.push({ path: "Home" });
  },
  computed: {
    ...mapState(["auth"]),
  },
  methods: {
    ...mapMutations(["setAuth"]),
    showPassword() {
      this.typePassword = this.typePassword == "text" ? "password" : "text";
    },

    login() {
      if (this.email && this.password) {
        this.onLogin = true;
        Api("login")
          .post({ email: this.email, password: this.password })
          .then((res) => {
            if (res.error) {
              this.onErrorLogin = true;
              return;
            }
              this.setAuth({
                username: this.email,
                jwt: res.data.token,
                id: res.data._id,
                posicion: res.data.posicion,
                pais: res.data.pais ? res.data.pais : "estados unidos",
                userType: res.data.userType,
              });
          })
          .catch(() => {
            this.onErrorLogin = true;
          })
          .finally(() => {
            this.onLogin = false;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
footer {
  position: absolute;
}

.login {
  height: 100%;
}

.container-login {
  width: 30em;
}
</style>